import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { Col, Form, Input } from 'reactstrap';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import { airportTransferInitialValues, validationSchema } from './constants';

const AirportTransfer = forwardRef(({ data, onDataChange }, ref) => {
  const {
    control,
    setValue,
    watch,
    trigger,
    getValues,
    setFocus,
    formState: { errors },
  } = useForm({
    defaultValues: airportTransferInitialValues,
    resolver: yupResolver(validationSchema),
    mode: 'onChange',
    shouldUnregister: false,
  });

  useImperativeHandle(ref, () => ({
    triggerAll: () => trigger(),
    triggerFields: names => trigger(names),
    getValues: () => getValues(),
    hasErrors: () => Object.keys(errors || {}).length > 0,
    focusFirstError: () => {
      const first = Object.keys(errors || {})[0];
      if (first) setFocus(first);
    },
  }));

  useEffect(() => {
    const sub = watch(values => onDataChange?.(values));
    return () => sub.unsubscribe();
  }, [watch, onDataChange]);

  useEffect(() => {
    if (!data) return;
    if (data.AirportTransferQuoteCost != null) {
      const n = Number(data.AirportTransferQuoteCost);
      setValue('airportTransferCost', Number.isFinite(n) && n !== 0 ? n : null);
    }
    if (data.AirportTransferComments != null) {
      setValue('airportTransferComments', data.AirportTransferComments);
    }
  }, [data, setValue]);

  return (
    <div className="ba-form d-flex flex-column gap-2">
      <div>
        <span className="fw-semibold">Airport Transfer</span>
      </div>
      <Form className="d-flex flex-row gap-2">
        <Col lg={3} className="external-filter-col">
          <span className="ba-form-label">
            Costs<span className="text-danger-tr">*</span>
          </span>
          <Controller
            control={control}
            name="airportTransferCost"
            render={({ field }) => (
              <Input
                className={`external-filter-input ${errors.airportTransferCost ? 'is-invalid' : ''}`}
                {...field}
                placeholder="0"
                type="number"
                onBlur={e => {
                  const val = e.target.value;
                  field.onChange(val === '' ? '' : parseFloat(val).toFixed(2));
                }}
              />
            )}
          />
          {errors.airportTransferCost && (
            <span className="text-danger-tr">
              {errors.airportTransferCost.message || 'Costs is required'}
            </span>
          )}
        </Col>
        <Col lg={9} className="external-filter-col">
          <span className="ba-form-label">Comment</span>
          <Controller
            control={control}
            name="airportTransferComments"
            render={({ field }) => (
              <Input
                className="external-filter-input"
                {...field}
                placeholder="Airport Transfer Comment"
                type="text"
              />
            )}
          />
        </Col>
      </Form>
    </div>
  );
});

export default AirportTransfer;
